module.exports = __webpack_public_path__ + "img/default_bg.c6930316.png";